module.exports = __webpack_public_path__ + "img/ic_fuqian.0b1d4088.png";